module.exports = __webpack_public_path__ + "img/4E4C42_B8C4C5_898E89_A3ACA4-256px.3dded2ee.png";